import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	labelButtonTitle: {
		id: 'custom-sites-extensions.config-panel.content.label-button.title',
		defaultMessage: 'Label',
		description: 'Title for label button in item config panel',
	},
	labelPopupTitle: {
		id: 'custom-sites-extensions.config-panel.content.label-button.popup.title',
		defaultMessage: 'Label',
		description: 'Title for label popup in item config panel',
	},
	hideLabelButtonText: {
		id: 'custom-sites-extensions.config-panel.content.label-button.popup.hide-label-button.text',
		defaultMessage: 'Hide label',
		description: 'Text for button that hides the label from an item',
	},
});
